import { render, staticRenderFns } from "./HomeTextTopicComponent.vue?vue&type=template&id=7ae92176&scoped=true&"
import script from "./HomeTextTopicComponent.vue?vue&type=script&lang=js&"
export * from "./HomeTextTopicComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeTextTopicComponent.vue?vue&type=style&index=0&id=7ae92176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae92176",
  null
  
)

export default component.exports